import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { tableAtom } from "../atoms";

export const useSyncTableQueryParams = (tablename) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [tableState, setTableState] = useRecoilState(tableAtom);

  useEffect(() => {
    const allowedLimits = [10, 20, 30, 40, 50, 100];

    let rawPage = parseInt(searchParams.get("page"));
    const page = isNaN(rawPage) || rawPage < 1 ? 1 : rawPage;

    let rawLimit = parseInt(searchParams.get("limit"));
    const limit = allowedLimits.includes(rawLimit) ? rawLimit : 20;

    const googleplacesName = (
      searchParams.get("googleplacesName") || ""
    ).trim();

    const skip = (page - 1) * limit;

    const newParams = {
      page,
      pagination: limit,
      skip,
    };

    setTableState((prev) => {
      if (!googleplacesName && prev.regexp?.googleplacesName) {
        return {
          ...prev,
          params: { ...prev.params, ...newParams },
          hydrated: tablename || "",
          regexp: undefined,
        };
      }

      return {
        ...prev,
        params: { ...prev.params, ...newParams },
        hydrated: tablename || "",
        ...(googleplacesName ? { regexp: { googleplacesName } } : {}),
      };
    });

    // SYNC URL IF NEEDED
    let updated = false;

    if (page !== rawPage) {
      searchParams.set("page", page.toString());
      updated = true;
    }

    if (limit !== rawLimit) {
      searchParams.set("limit", limit.toString());
      updated = true;
    }

    if (updated) {
      navigate(`?${searchParams.toString()}`, { replace: true });
    }
  }, [tablename]);
};
